<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiMenuUp } from "@mdi/js";
export default {
  name: "MdiMenuUp",
  data() {
    return {
      svgPath: mdiMenuUp,
    };
  },
};
</script>
